export default __webpack_public_path__ + "static/media/TV.55085f51.svg";